import Grid from "@material-ui/core/Grid"
import {Typography} from "@material-ui/core"
import QuantityButton from "../QuantitiyButton"
import {
	addWorker,
	hasHeavyItem,
	removeWorker,
	setTruckWorkers,
} from "../../../actions/actionCreators"
import React, {useEffect} from "react"
import {connect} from "react-redux"
import i18n from "../../../i18nextInitiator"

const t = i18n.getFixedT("fa", "general")

const WorkerSelector = (props) => {
	const {
		order: {
			barbar_worker: workersNum,
			origin_floor,
			destination_floor,
			vasayeleHazinedar,
		},
		selectService,
	} = props

	useEffect(() => {
		if (selectService === 2) setTruckWorkers(origin_floor + destination_floor)
	}, [selectService, origin_floor, destination_floor])

	useEffect(() => {
		if (selectService !== 2) setTruckWorkers(origin_floor + destination_floor)
	}, [selectService, origin_floor, destination_floor, vasayeleHazinedar])

	const realWorkersNum = workersNum - 1

	return (
		<Grid container justifyContent={"space-between"}>
			<Grid item xs='7' md='8' style={{margin: "auto 0"}}>
				<Typography style={{fontSize: 16}}>{t(`worker.title`)}</Typography>
				{selectService === 2
					? workersNum > 1 && (
							<Typography variant={"subtitle2"}>
								{t(`worker.desc`, {workersNum: realWorkersNum})}
							</Typography>
					  )
					: workersNum > 1 && (
							<Typography variant={"subtitle2"}>
								{t(`worker.descheavyload`, {workersNum: realWorkersNum})}
							</Typography>
					  )}
				{selectService === 2
					? workersNum === 1 && (
							<Typography variant={"subtitle2"}>
								{t(`worker.oneselect`)}
							</Typography>
					  )
					: workersNum === 1 && (
							<Typography variant={"subtitle2"}>
								{t(`worker.oneselectheavyload`)}
							</Typography>
					  )}
				{workersNum === 0 && (
					<Typography variant={"subtitle2"}>
						{t(`worker.descnotselectworker`)}
					</Typography>
				)}
			</Grid>
			<Grid item xs='5' md='4' style={{textAlign: "end"}}>
				<QuantityButton
					value={workersNum}
					add={addWorker}
					remove={removeWorker}
				/>
			</Grid>
		</Grid>
	)
}

const mapStateToProps = (state) => ({...state.order})

export default connect(mapStateToProps)(WorkerSelector)
